import React from "react";
import {browserHistory} from "react-router";
import {Base64} from 'js-base64';
import {Modal, Toast} from 'antd-mobile';

import {CartFetch, ClientFetch, ShopFetch, System} from "../config/route-fetch";
import {SystemConst} from "./constant";
import StorageUtil from "./storage-util";
import UrlUtil from "./url-config";
import AppUtil from "../utils/app-util";
import Util from "../utils/Utils";
import CheckUtil from "./check-util";
import {BusinessUtil} from "./BusinessUtil";
import {syncAuthToMiniProgram} from "./mini-program-auth-sync";

const _charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789';

function safeDecodeURIComponent(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value;
    }
}

export const CommonUtil = {
    initCompanySetting() {
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        const platformCompanyId = StorageUtil.getItem(SystemConst.platformCompanyId);
        if (!platformCompanyId && !companyId) return;
        // 商城设置信息
        InitUtil.getShopCompanySetting(platformCompanyId || companyId);
        // 注册设置
        InitUtil.getShopRegisterSetting(platformCompanyId || companyId);
        // 商品设置信息
        InitUtil.getGoodsSetting(platformCompanyId || companyId);
        // 商品分类信息
        InitUtil.listTypeByCompany(platformCompanyId || companyId);
    },
    /**
     * 异步版本的initCompanySetting（性能优化：并行请求）
     * @param companyId 公司ID
     * @param platformCompanyId 平台公司ID
     * @returns Promise 并行请求所有设置信息
     */
    initCompanySettingAsync(companyId, platformCompanyId) {
        return new Promise((resolve, reject) => {
            const targetCompanyId = platformCompanyId || companyId;
            if (!targetCompanyId) {
                resolve(null);
                return;
            }
            // 并行请求所有设置信息
            Promise.all([
                InitUtil.getShopCompanySetting(targetCompanyId),
                InitUtil.getShopRegisterSetting(targetCompanyId),
                InitUtil.getGoodsSetting(targetCompanyId),
                InitUtil.listTypeByCompany(targetCompanyId)
            ]).then(results => {
                resolve(results);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setTheme: (theme) => {
        document.body.className = `page-reset theme-${theme || 'ffb919'}`;
        const $jsFullLoading = document.getElementById("jsFullLoading");
        if ($jsFullLoading) {
            document.body.removeChild($jsFullLoading);
        }
    },

    // 前往订货端体验账号
    toShopExperience() {
        return new Promise((resolve, reject) => {
            const companyId = StorageUtil.getItem(SystemConst.companyId);
            System.shopExperience({
                company_: companyId
            }, rs => {
                if (rs.status === 1 && rs.data.type_ === 3) {
                    // app缓存用户信息
                    AppUtil.saveUserInfo(rs.data);
                    const auth_code_ = Base64.encode(JSON.stringify({
                        bind_phone_: rs.data.bind_phone_,
                        company_id_: rs.data.company_id_,
                        company_name_: rs.data.company_name_,
                        company_theme_: rs.data.company_theme_,
                        client_id_: rs.data.client_id_,
                        env_: rs.data.env_,
                        login_: rs.data.login_,
                        id_: rs.data.id_,
                        name_: rs.data.name_,
                        phone_: rs.data.phone_,
                        type_: rs.data.type_,
                        token_: rs.data.token_,
                        head_img_: rs.data.head_img_,
                        auth_code_: rs.data.auth_code_,
                        duty_name_: rs.data.duty_name_,
                        dept_name_: rs.data.dept_name_,
                    }));
                    // 更新数据中心数据并跳转
                    window.location.href = `${UrlUtil.getMShopUrl()}/shop?companyId=${companyId}&auth_code_=${auth_code_}`;

                    resolve(rs);
                } else {
                    reject(rs);
                    Util.message('数据错误，请联系客服');
                }
            })
        })
    },
    //跳转管理端体验
    toMgrExperience() {
        if (!AppUtil.isApp && process.env.API_ENV === 'production') {
            browserHistory.replaceState(null, '/shop/JumpError');
            return
        }
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        System.experience({company_: companyId}, rs => {
            if (rs.status === 1 && rs.data.type_ !== 3) {
                // if (AppUtil.isApp) {
                //     AppUtil.jsCallAppParam(6, {message: JSON.stringify(rs.data)});
                //     return;
                // }
                AppUtil.saveUserInfo(rs.data);
                const auth_code_ = Base64.encode(JSON.stringify({
                    bind_phone_: rs.data.bind_phone_,
                    company_id_: rs.data.company_id_,
                    company_name_: rs.data.company_name_,
                    company_theme_: rs.data.company_theme_,
                    client_id_: rs.data.client_id_,
                    env_: rs.data.env_,
                    login_: rs.data.login_,
                    id_: rs.data.id_,
                    name_: rs.data.name_,
                    phone_: rs.data.phone_,
                    type_: rs.data.type_,
                    token_: rs.data.token_,
                    head_img_: rs.data.head_img_,
                    auth_code_: rs.data.auth_code_,
                    duty_name_: rs.data.duty_name_,
                    dept_name_: rs.data.dept_name_,
                }));
                // 更新数据中心数据并跳转
                window.location.href = `${UrlUtil.getMMgrUrl()}/home?companyId=${companyId}&auth_code_=${auth_code_}`

            } else {
                Util.message('数据错误，请联系客服');
            }
        })

    },
    //跳转管理端体验
    companyShopToMgr() {
        this.ysClient = JSON.parse(localStorage.getItem(SystemConst.ysClient));
        const clientId = this.ysClient.id_;
        ClientFetch.companyShopToMgr(clientId, rs => {
            if (rs.status === 1 && rs.data.type_ !== 3) {
                // if (AppUtil.isApp) {
                //     AppUtil.jsCallAppParam(6, {message: JSON.stringify(rs.data)});
                //     return;
                // }
                AppUtil.saveUserInfo(rs.data);
                const auth_code_ = Base64.encode(JSON.stringify({
                    bind_phone_: rs.data.bind_phone_,
                    company_id_: rs.data.company_id_,
                    company_name_: rs.data.company_name_,
                    company_theme_: rs.data.company_theme_,
                    client_id_: rs.data.client_id_,
                    env_: rs.data.env_,
                    login_: rs.data.login_,
                    id_: rs.data.id_,
                    name_: rs.data.name_,
                    phone_: rs.data.phone_,
                    type_: rs.data.type_,
                    token_: rs.data.token_,
                    head_img_: rs.data.head_img_,
                    auth_code_: rs.data.auth_code_,
                    duty_name_: rs.data.duty_name_,
                    dept_name_: rs.data.dept_name_,
                    company_shop_switch_: rs.data.company_shop_switch_,
                }));
                // 更新数据中心数据并跳转
                window.location.href = `${UrlUtil.getMMgrUrl()}/home?companyId=${rs.data.company_id_}&auth_code_=${auth_code_}`

            } else {
                Util.message('数据错误，请联系客服');
            }
        })

    },
    // 获取url参数
    getSearchFromUrl(search = window.location.search) {
        let searchObj = {};
        const subIndex = search.indexOf("?");
        if (subIndex > -1) {
            search = search.substr(subIndex + 1);
        }
        search.split('&').map(item => {
            const itemArr = item.split("=");
            if (itemArr[0] && itemArr[1]) {
                searchObj[itemArr[0]] = itemArr[1];
            }
        });
        return searchObj;
    },
    // 设置价格精度
    priceScale(price, scale = 2) {
        if (!price) return 0;
        if (isNaN(Number(price))) return;
        var times = Math.pow(10, scale);
        var s1 = price.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;
        var priceZoom = (s1 * Math.pow(10, m)) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;

        return +des.toFixed(scale);
    },
    // 替换表情
    replaceEmoji(v) {
        if (!v.trim()) return v;
        return v.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83C[\uDC00-\uDFFF]/g, "")
    },
    //时间格式化
    formatDate(date) {
        const pad = n => n < 10 ? `0${n}` : n;
        const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        return `${dateStr} ${timeStr}`;
    },
    // 获取动画样式
    getTransitionName({pathname}) {
        const localHistory = StorageUtil.getItem(SystemConst.localHistory, true);
        // 上一级路由
        const prevPathName = (localHistory[localHistory.length - 2] || {}).pathname;
        // 一级导航路由
        const barPathname = StorageUtil.getItem(SystemConst.barPathname);
        const tabRouter = barPathname || ['/shop/GoodsList', '/shop/OrderList', '/shop/RefundList', '/shop/CartList', '/shop/User'];
        let transitionName = 'page';
        if (prevPathName) {
            // 进入一级页面
            if (tabRouter.includes(pathname)) {
                if (!tabRouter.includes(prevPathName)) {
                    transitionName = 'page-back'
                }
            } else {
                transitionName = 'page-go'
            }
            // 订货单 <==> 退货单 、常用清单 <==> 退货单切换不启动动画
            const closeAnime = [
                {pathname: `/shop/OrderList`, prevPathName: `/shop/RefundList`},
                {pathname: `/shop/RefundList`, prevPathName: `/shop/OrderList`},
                {pathname: `/shop/KeepList`, prevPathName: `/shop/MyCollect`},
                {pathname: `/shop/MyCollect`, prevPathName: `/shop/KeepList`},

                // {pathname: `/shop/IntegralOrder`, prevPathName: `/shop/Integral`},
            ];
            if (closeAnime.findIndex(item => item.pathname === pathname && item.prevPathName === prevPathName) > -1) {
                transitionName = 'page';
            }
            const backAnime = [
                {pathname: `/shop/GoodsListLabel`, prevPathName: `/shop/GoodsDetail`}, // 商品分类页面<==>商品详情
                {pathname: `/shop/GeneralizeGoods`, prevPathName: `/shop/GoodsDetail`}, // 推广商品<==>商品详情
                {pathname: `/shop/MyCollect`, prevPathName: `/shop/GoodsDetail`}, // 我的收藏<==>商品详情
                {pathname: `/shop/KeepList`, prevPathName: `/shop/GoodsDetail`}, // 常用清单<==>商品详情
                {pathname: `/shop/GoodsList`, prevPathName: `/shop/GoodsDetail`}, // 商品列表<==>商品详情
                {pathname: `/shop/UserFootprint`, prevPathName: `/shop/GoodsDetail`}, // 最近浏览<==>商品详情
                {pathname: `/shop/GoodsSearchResult`, prevPathName: `/shop/GoodsDetail`}, //
                {pathname: `/shop/GoodsListLabel`, prevPathName: `/shop/GoodsSearch`}, //

                {pathname: `/shop/GoodsDetail`, prevPathName: `/shop/GoodsMessage`},
                {pathname: `/shop/GoodsDetail`, prevPathName: `/shop/NoticeDetail`},
                {pathname: `/shop/GoodsDetail`, prevPathName: `/shop/ShopNotice`},

                {pathname: `/shop/PerformanceStatistics`, prevPathName: `/shop/ClientOrderStatistics`}, // 商品推广订单 => 业绩统计

                {pathname: `/shop/WithdrawDeposit`, prevPathName: `/shop/WithdrawAccount`},
                {pathname: `/shop/GoodsClassifyFilter`, prevPathName: `/shop/GoodsListLabel`},// 商品分类列表
                {pathname: `/shop/GoodsGroupClassifyFilter`, prevPathName: `/shop/GoodsListLabel`},// 商品分类列表
                {pathname: `/shop/ShopNotice`, prevPathName: `/shop/NoticeDetail`},
                {pathname: `/shop/RefundList`, prevPathName: `/shop/RefundDetail`},
                {pathname: `/shop/RefundList`, prevPathName: `/shop/RefundApply`},
                {pathname: `/shop/RefundDetail`, prevPathName: `/shop/RefundResult`},
                {pathname: `/shop/OrderDetail`, prevPathName: `/shop/RefundApply`},
                {pathname: `/shop/RefundApply`, prevPathName: `/shop/RefundProduct`},
                {pathname: `/shop/RefundList`, prevPathName: `/shop/RefundResult`},
                {pathname: `/shop/OrderStatistics`, prevPathName: `/shop/OrderStatisticsDetail`},

                {pathname: `/shop/Integral`, prevPathName: `/shop/IntegralList`},
                {pathname: `/shop/Integral`, prevPathName: `/shop/IntegralFlow`},
                {pathname: `/shop/Integral`, prevPathName: `/shop/IntegralOrder`},
                {pathname: `/shop/IntegralList`, prevPathName: `/shop/IntegralDetail`},
                {pathname: `/shop/IntegralRule`, prevPathName: `/shop/IntegralRuleDetail`},

                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/PerformanceStatistics`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/ClientStatistics`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/ClientStatistics`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/ClientOrderStatistics`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/GeneralizeGoods`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/InvitationHome`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/SettlementHome`},
                {pathname: `/shop/DistributionHome`, prevPathName: `/shop/WithdrawAccount`},

                {pathname: `/shop/SettlementHome`, prevPathName: `/shop/AccountLog`},
                {pathname: `/shop/SettlementHome`, prevPathName: `/shop/WithdrawLog`},
                {pathname: `/shop/SettlementHome`, prevPathName: `/shop/WithdrawDeposit`},
                {pathname: `/shop/GoodsPromotionList`, prevPathName: `/shop/GoodsListLabel`},
                {pathname: `/shop/OrderBatchPay`, prevPathName: `/shop/OrderDetail`},
                {pathname: `/shop/page`, prevPathName: `/shop/page`},
                {pathname: `/shop/DepositDetail`, prevPathName: `/shop/DepositRecharge`},

                {pathname: `/shop/Custom`, prevPathName: `/shop/Custom/Search`},
                {pathname: `/shop/Custom/Search`, prevPathName: `/shop/Custom/Goods`},
                {pathname: `/shop/Custom/Goods`, prevPathName: `/shop/CartOrder`},
                {pathname: `/shop/Custom`, prevPathName: `/shop/Custom/Goods`},
                {pathname: `/shop/GoodsDetail`, prevPathName: `/shop/Custom`},

                {pathname: `/shop/Custom`, prevPathName: `/shop/page`},

                {pathname: `/shop/SettleAccountsDetail`, prevPathName: `/shop/DepositDetail`},
                {pathname: `/shop/SettleAccountsDetail`, prevPathName: `/shop/BackAccountDetail`},
                {pathname: `/shop/InvoiceAssistantList`, prevPathName: `/shop/InvoiceAssistantDetail`},
            ];

            if (backAnime.findIndex(item => item.pathname === pathname && item.prevPathName === prevPathName) > -1) {
                transitionName = 'page-back'
            }

        }
        // fix:YSDH-9353 微页面跳转到微页面的动画修改为渐变动画
        if (pathname === '/shop/page' && localHistory[localHistory.length - 1].pathname === '/shop/page') {
            transitionName = 'page-back'
        }
        return transitionName;
    },
    // 获取装修跳转路径
    getDecorateLocation(target) {
        const applicationStatus = StorageUtil.getItem(SystemConst.applicationStatus);
        const goodsTypeSetting = StorageUtil.getItem(SystemConst.goodsTypeSetting) || {};
        const companyOpenScore = StorageUtil.getItem(SystemConst.companyOpenScore);
        const companyEnableSign = StorageUtil.getItem(SystemConst.companyEnableSign);
        if (typeof target === "undefined") return;
        const newLocation = {
            query: {
                companyId: StorageUtil.getItem(SystemConst.companyId)
            }
        };
        switch (target.type_) {
            case 1: //已上架商品
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsDetail";
                newLocation.query.id = target.val_;
                break;
            case 2: //商品分类
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                // YSDH-8715: fix 从装修的功能导航点击进来未选中分类
                // newLocation.query.type_ = `${target.key_ ? target.key_ + ',' : ''}${target.val_}`;
                newLocation.query.type_ = target.val_;
                newLocation.query.showTagFilter = true;
                break;
            case 3: //商品标签
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.tag_ = target.val_;
                newLocation.query.showTagFilter = true;
                break;
            case 4: //商品品牌
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.brand_ = target.val_;
                break;
            case 5: //通知公告
                if (!target.val_) return;
                newLocation.pathname = "/shop/NoticeDetail";
                newLocation.query.id = target.val_;
                break;
            case 6: //商品促销
                if (!target.val_) return;
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.goods_activity_id_ = target.val_;
                break;
            case 7: //模板页面
                if (!target.val_) return;
                newLocation.pathname = "/shop/page";
                newLocation.query.pid = target.val_;
                break;
            case 8: //外部链接
                if (!CheckUtil.isUrl(target.val_)) return;
                if (AppUtil.isApp) {
                    AppUtil.goWeb(target.val_, name)
                } else {
                    window.location.href = `${target.val_}`;
                }
                break;
            case 9: // 全部商品
                newLocation.pathname = "/shop/GoodsList";
                break;
            case 10: // 购物车
                newLocation.pathname = "/shop/CartList";
                break;
            case 11: // 收藏商品
                // props.history.pushState(null, "/shop/MyCollect", {tag_: '-1,'});
                newLocation.pathname = "/shop/MyCollect";
                newLocation.query.tag_ = `-1`;
                break;
            case 12: // 常用商品(常购商品)
                newLocation.pathname = "/shop/KeepList";
                break;
            case 13: // 全部分类
                newLocation.pathname = goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter";
                break;
            case 14: // 领券中心
                newLocation.pathname = "/shop/ReceiveCoupon";
                break;
            case 16: // 限时特卖
            case 17: // 限时秒杀
                //暂无限时特卖以及限时秒杀
                break;
            case 18: // 通知公告列表
                newLocation.pathname = "/shop/ShopNotice";
                break;
            case 19: // 个人中心
                newLocation.pathname = "/shop/User";
                break;
            case 20: // 我的订单
                newLocation.pathname = "/shop/OrderList";
                break;
            case 21: // 签到好礼
                if (!companyOpenScore && !companyEnableSign) {
                    Toast.info('暂不支持签到！');
                    newLocation.pathname = '';
                } else {
                    newLocation.pathname = "/shop/IntegralSign";
                }
                break;
            case 22: // 我的积分
                newLocation.pathname = "/shop/Integral";
                break;
            case 23: // 商品属性
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.property_id_ = target.val_;
                break;
            case 24: // 预售商品
                newLocation.pathname = "/shop/GoodsListLabel";
                newLocation.query.quick_search_ = 6;
                break;
            case 25: // 首页
                newLocation.pathname = "/shop";
                break;
            case 26: // 全部促销
                newLocation.pathname = "/shop/GoodsPromotionList";
                break;
            case 27: // 商品套餐
                newLocation.pathname = "/shop/GoodsPackageList";
                break;
            case 28: // 商品品牌
                newLocation.pathname = "/shop/GoodsBrandList";
                break;
            case 30: // 预存款充值
                newLocation.pathname = "/shop/DepositRecharge";
                break;
            case 31: // 体验馆
                newLocation.pathname = "/shop/ExperienceList";
                break;
            case 32: // 金饰定制
                if (!applicationStatus.application_39_status_) {
                    Toast.info('请先开启金饰定制应用', 3, null, false);
                    return newLocation;
                }
                newLocation.pathname = "/shop/Custom";
                break;
            case 34: // 串号查询
                newLocation.pathname = "/shop/GoodsSnSearch";
                break;
        }
        return newLocation;
    },
    // 获取导航pathname
    getBarPathname(buttons) {
        if (!buttons) return;
        const goodsTypeSetting = StorageUtil.getItem(SystemConst.goodsTypeSetting) || {};
        const barPathname = [];
        buttons.forEach(item => {
            const target = item.target_;
            if (!target) return;
            switch (target.type_) {
                case 1: //已上架商品
                    barPathname.push("/shop/GoodsDetail");
                    break;
                case 2: //商品分类
                case 3: //商品标签
                case 4: //商品标签
                case 6: //商品促销
                case 23: // 商品属性
                case 24: // 预售商品
                    barPathname.push("/shop/GoodsListLabel");
                    break;
                case 5: //通知公告
                    barPathname.push("/shop/NoticeDetail");
                    break;
                case 7: //模板页面
                    barPathname.push("/shop/page");
                    break;
                case 8: //外部链接
                    break;
                case 9: // 全部商品
                    barPathname.push("/shop/GoodsList");
                    break;
                case 10: // 购物车
                    barPathname.push("/shop/CartList");
                    break;
                case 11: // 收藏商品
                    barPathname.push("/shop/MyCollect");
                    break;
                case 12: // 常用商品(常购商品)
                    barPathname.push("/shop/KeepList");
                    break;
                case 13: // 全部分类
                    barPathname.push(goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter");
                    break;
                case 14: // 领券中心
                    barPathname.push("/shop/ReceiveCoupon");
                    break;
                case 16: // 限时特卖
                case 17: // 限时秒杀
                    //暂无限时特卖以及限时秒杀
                    break;
                case 18: // 通知公告列表
                    barPathname.push("/shop/ShopNotice");
                    break;
                case 19: // 个人中心
                    barPathname.push("/shop/User");
                    break;
                case 20: // 我的订单
                    barPathname.push("/shop/OrderList");
                    break;
                case 21: // 签到好礼
                    barPathname.push("/shop/IntegralSign");
                    break;
                case 22: // 我的积分
                    barPathname.push("/shop/Integral");
                    break;
                case 25: // 首页
                    barPathname.push("/shop");
                    break;
                case 31: // 体验馆
                    barPathname.push("/shop/ExperienceList");
                    break;
            }
        });
        return barPathname;
    },
    // 微信绑定
    toWechatBind() {
        if (CheckUtil.isWeiXin) {
            const wechatBind = StorageUtil.getItem(SystemConst.wechatBind);
            // console.log('check has bind', wechatBind);
            if (!wechatBind) {
                const companyData = StorageUtil.getItem(SystemConst.companyData);
                // console.log('check has wechat_setting_is_open_login_auth_', companyData.wechat_setting_is_open_login_auth_)
                // console.log('check has wechat_setting_wechat_appid_', companyData.wechat_setting_wechat_appid_)
                if (companyData.wechat_setting_is_open_login_auth_ && companyData.wechat_setting_wechat_appid_) {
                    /*
                     由于微信授权会重定向url,sessionStore的值会丢失
                     所以这里使用微信授权提供的state携带参数
                     参考文档:https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842
                     使用V作为参数间隔
                     */
                    const query = CommonUtil.getSearchFromUrl();
                    const state = [companyData.id_, query.id]; // [企业id,商品id];
                    // console.log('redirect_uri', location.href);
                    // console.log('redirect_uri state', state);

                    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${companyData.wechat_setting_wechat_appid_}&redirect_uri=${location.href}&response_type=code&scope=snsapi_userinfo&state=${state.join('V')}#wechat_redirect`;
                    window.location.href = url;
                }
            }
        }
    },
    // 保存登录信息
    saveStorageFormLogin(loginUser, rawAuthCode) {
        StorageUtil.setItem(SystemConst.mShop_user, loginUser);
        StorageUtil.setItem(SystemConst.token, loginUser.token_);
        StorageUtil.setItem(SystemConst.companyId, loginUser.company_id_);
        StorageUtil.setItem(SystemConst.companyName, loginUser.company_name_);
        StorageUtil.setItem(SystemConst.companyTheme, loginUser.company_theme_);
        StorageUtil.setItem(SystemConst.authCode, loginUser.auth_code_);
        // YSDH-7542
        StorageUtil.setItem(SystemConst.isShowBindTips, 1);
        StorageUtil.setItem(SystemConst.isLighting, loginUser.isLighting || 0);
        // 3_1_9:是否微信绑定
        StorageUtil.setItem(SystemConst.wechatBind, loginUser.wechat_bind_);
        //店铺切换账号是否可用
        StorageUtil.setItem(SystemConst.companyShopSwitch, loginUser.company_shop_switch_);
        if (loginUser && loginUser.token_ && loginUser.company_id_) {
            syncAuthToMiniProgram(rawAuthCode || Base64.encode(JSON.stringify(loginUser)), loginUser);
        }
    },
    captureShopCloneEntryCodeFromUrl(search) {
        const query = CommonUtil.getSearchFromUrl(search || window.location.search);
        const entryCode = query.entryCode || query.entry_code_;
        if (entryCode) {
            StorageUtil.setItem(SystemConst.shopCloneEntryCode, safeDecodeURIComponent(entryCode));
        }
    },
    getShopCloneEntryCode() {
        const query = CommonUtil.getSearchFromUrl();
        const urlEntryCode = query.entryCode || query.entry_code_;
        if (urlEntryCode) {
            const decodedEntryCode = safeDecodeURIComponent(urlEntryCode);
            StorageUtil.setItem(SystemConst.shopCloneEntryCode, decodedEntryCode);
            return decodedEntryCode;
        }
        if (StorageUtil.getItem(SystemConst.enableShopClone) !== 1) {
            return '';
        }
        const entryCode = StorageUtil.getItem(SystemConst.shopCloneEntryCode);
        return entryCode ? safeDecodeURIComponent(entryCode) : '';
    },
    checkLoginStatus(loginStatus) {
        if (typeof loginStatus !== 'number') return null;
        let companyDate = StorageUtil.getItem(SystemConst.companyData);
        const link_phone_ = (companyDate && companyDate.link_phone_) || '0755-2665 9381';
        const company_name_ = companyDate && companyDate.name_;
        const actions = [{text: '我知道了'}, {
            text: '呼叫', onPress: () => {
                return new Promise(() => {
                    window.location.href = `tel:${link_phone_}`
                });

            }
        }];
        const telNode = <a href={`tel:${link_phone_}`}>（{link_phone_}）</a>;
        switch (loginStatus) {
            case 0:
                break;
            case 1:
                // Toast.success(`登录成功`, 1);
                return true;
            case 2:
                Toast.hide();
                Modal.alert(null, <div>登录账号不存在<br/>请联系管理员开通<br/>{telNode}</div>, actions);
                break;
            case 3:
                //账号禁用
                Toast.hide();
                Modal.alert(null, <div>该企业账号被禁用<br/>请联系云上订货<br/>{telNode}</div>, actions);
                break;
            case 4:
                //试用结束
                Toast.hide();
                Modal.alert(null, <div>该企业账号试用期结束<br/>请联系云上订货<br/>{telNode}</div>, actions);
                break;
            case 5:
                //使用过期
                Toast.hide();
                Modal.alert(null, <div>该企业账号已过期了<br/>需要续费才能使用<br/>请联系云上订货 <br/>{telNode}</div>, actions);
                break;
            case 6:
                //使用过期
                Toast.hide();
                Modal.alert(null, <div>该企业不存在此帐号</div>, [{text: '我知道了'}]);
                break;
            case 7:
                // 客户账号已禁用
                Toast.hide();
                Modal.alert(null, <div>您的订货账号已被企业{company_name_}禁用，不可登录。请联系管理员{telNode}</div>, actions);
                break;
            case 8:
                // 客户账号已停用
                Toast.hide();
                Modal.alert(null, <div>您已不是企业{company_name_}的合作客户，不可登录。请联系管理员{telNode}</div>, actions);
                break;
            case 9:
                // 店铺账号已禁用
                Toast.hide();
                Modal.alert(null, <div>您的店铺已被停用，不可登录。请联系管理员{telNode}
                </div>, actions);
                break;
            case 10:
                // tv未开通装修专版
                Toast.hide();
                Modal.alert(null, <div>该账号未开通灯饰专版功能。请联系管理员{telNode}</div>, actions);
                break;
            default:
                Toast.info(`数据异常请重新尝试或者联系管理员`, 1, null, false);
        }

    },
    setStatisticalCode(data) {
        let body = document.getElementsByTagName("body")[0];
        if (data) {
            data = JSON.parse(data);
            data.forEach(item => {
                let scriptDom = document.createElement("script");
                scriptDom.type = "text/javascript";
                scriptDom.src = item.name;
                body.appendChild(scriptDom);
            })
        } else {
            let scriptDom = document.createElement("script");
            scriptDom.type = "text/javascript";
            scriptDom.src = 'https://hm.baidu.com/hm.js?5c6da7c14905c6a9a405904833d3dd8d';
            body.appendChild(scriptDom);
        }
    },
    //数据格式转换
    stringToArr(string) {
        if (Array.isArray(string)) return string;
        try {
            return JSON.parse(string) || []
        } catch (e) {
            return []
        }
    },
    stringToObj(string) {
        if (!string) return;
        if (CommonUtil.isType(string) === 'Object') return string;

        try {
            return JSON.parse(string) || {}
        } catch (e) {
            return {}
        }
    },
    handleMultiUnits(multi_unit_) {
        const usableUnitList = [];
        if (multi_unit_.usable_[0] === 1) {
            usableUnitList.push(multi_unit_.unit_id_);
        }
        (multi_unit_.extend_units_ || []).map((unit, index) => {
            if (unit.unit_id_ && multi_unit_.usable_[index + 1] === 1) { // 可订货单位
                usableUnitList.push(unit.unit_id_);
            }
        });
        return usableUnitList;
    },
    isType(value) {
        const type = Object.prototype.toString.call(value);
        return type.replace(/\[object (\w+)\]/, '$1')
    },
    /**
     * 随机生成索引
     * @param min 最小值
     * @param max 最大值
     * @param i 当前获取位置
     */
    randomIndex(min, max, i) {
        var index = Math.floor(Math.random() * (max - min + 1) + min),
            numStart = _charStr.length - 10;
        //如果字符串第一位是数字，则递归重新获取
        if (i == 0 && index >= numStart) {
            index = this.randomIndex(min, max, i);
        }
        //返回最终索引值
        return index;
    },
    /**
     * 随机生成字符串
     * @param len 指定生成字符串长度
     */
    getRandomString(len) {
        var min = 0, max = _charStr.length - 1, _str = '';
        //判断是否指定长度，否则默认长度为15
        len = len || 15;
        //循环生成字符串
        for (var i = 0, index; i < len; i++) {
            index = this.randomIndex(min, max, i);
            _str += _charStr[index];
        }
        return _str;
    },
    getRandomParam() {
        var nonce = this.getRandomString(20);
        /*if (url.indexOf('?') > -1) {
            url += "&nonce=" + nonce;
        } else {
            url += "?nonce=" + nonce;
        }*/
        return nonce;
    },
    objSort(arys) {
        //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
        if (!arys) {
            return {};
        }
        var newkey = Object.keys(arys).sort();
        //console.log('newkey='+newkey);
        var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
        for (var i = 0; i < newkey.length; i++) {
            //遍历newkey数组
            newObj[newkey[i]] = arys[newkey[i]];
            //向新创建的对象中按照排好的顺序依次增加键值对
        }
        return newObj; //返回排好序的新对象
    },
    getNonce() {
        let nonce = new Date().getTime() + '' + Math.floor(Math.random() * 10000);
        return nonce;
    },

};
export const InitUtil = {
    getCompanySetting() {
        return new Promise((resolve, reject) => {
            System.getCompanySetting({}, rs => {
                if (rs.status === 1) {
                    StorageUtil.setItem(SystemConst.enableOrderSource, !!rs.data.enable_order_source_);
                    resolve(rs)
                } else {
                    reject(rs)
                }
            });
        })
    },
    // 获取商城设置
    getShopCompanySetting(companyId) {
        return new Promise((resolve, reject) => {
                System.getShopCompanySetting(companyId, rs => {
                    if (rs.status === 1) {
                        const {goodsSetting, houseSetting, saleSetting, shopSetting, incomeSetting, distributionRebateSetting, top_goods_type_node_, sceneSettingDto} = rs.data;
                        if (incomeSetting) {
                            // 启用客户资金充值扣款审核后，客户资金的充值及扣款需审核后才生效
                            StorageUtil.setItem(SystemConst.enableRechargeDeductConfirm, incomeSetting.enable_recharge_deduct_confirm_);
                            // 启用后客户在商城端使用线下转账方式时必须上传附件
                            StorageUtil.setItem(SystemConst.enableCustomAttachmentRequired, incomeSetting.enable_custom_attachment_required_);
                            StorageUtil.setItem(SystemConst.enableChangeInvoice, incomeSetting.enable_change_invoice_);
                            StorageUtil.setItem(SystemConst.enableCustomAttachmentClose, incomeSetting.enable_custom_attachment_close_);
                            StorageUtil.setItem(SystemConst.huiFuWeiXinCombinedPay, incomeSetting.huifu_weixin_combined_pay_);
                        }
                        // 商品设置
                        if (goodsSetting) {
                            // 是否可以下载商品图片
                            StorageUtil.setItem(SystemConst.enableGoodsImgDownload, goodsSetting.enable_goods_img_download_);
                            // 是否开启起订量
                            StorageUtil.setItem(SystemConst.enableMinCount, goodsSetting.min_count_);
                            // 是否开启限订量
                            StorageUtil.setItem(SystemConst.enableMaxCount, goodsSetting.max_count_);
                            // 是否开启品牌筛选
                            StorageUtil.setItem(SystemConst.enableBrand, goodsSetting.enable_brand_);
                            // 是否开启风格筛选
                            StorageUtil.setItem(SystemConst.enableStyle, goodsSetting.enable_style_);
                            //商品价格精度
                            StorageUtil.setItem(SystemConst.priceScale, goodsSetting.price_scale_ && goodsSetting.price_scale_);
                            //商品数量精度
                            StorageUtil.setItem(SystemConst.countScale, goodsSetting.count_scale_ && goodsSetting.count_scale_);
                            // 客户端显示体积
                            StorageUtil.setItem(SystemConst.clientShowCubage, goodsSetting.client_show_cubage_);
                            StorageUtil.setItem(SystemConst.clientShowWeight, goodsSetting.client_show_weight_);
                        }
                        if (houseSetting) {
                            StorageUtil.setItem(SystemConst.houseSetting, houseSetting)
                        }
                        if (saleSetting) {
                            StorageUtil.setItem(SystemConst.saleSetting, saleSetting);
                            StorageUtil.setItem(SystemConst.stockShowType, saleSetting.stock_show_type_);
                            // 是否允许超售
                            StorageUtil.setItem(SystemConst.enableStockZero, saleSetting.enable_stock_zero_);

                            // 交货日期是否必填
                            StorageUtil.setItem(SystemConst.enableExpectTime, saleSetting.enable_expect_time_);
                            // 开启下单金额限制
                            StorageUtil.setItem(SystemConst.enableOrderTotal, saleSetting.enable_order_total_);
                            StorageUtil.setItem(SystemConst.orderTotal, saleSetting.order_total_);
                            // 开启特批价
                            StorageUtil.setItem(SystemConst.enableSpecialTotal, saleSetting.enable_special_total_);
                            // 是否可开发票
                            StorageUtil.setItem(SystemConst.enableTax, saleSetting.enable_tax_);
                            StorageUtil.setItem(SystemConst.containTax, saleSetting.contain_tax_);
                            StorageUtil.setItem(SystemConst.generalTax, saleSetting.general_tax_);
                            StorageUtil.setItem(SystemConst.addedTax, saleSetting.added_tax_);
                            StorageUtil.setItem(SystemConst.otherTax, saleSetting.other_tax_);
                            StorageUtil.setItem(SystemConst.taxType, saleSetting.tax_types_);
                            StorageUtil.setItem(SystemConst.defaultTaxType, saleSetting.default_tax_type_);

                            StorageUtil.setItem(SystemConst.orderDefaultUnit, saleSetting.order_default_unit_);
                            StorageUtil.setItem(SystemConst.enableSaleBackOrder, saleSetting.enable_sale_back_order_);
                            let additional_fee_setting_ = saleSetting.additional_fee_setting_json_ && JSON.parse(saleSetting.additional_fee_setting_json_);
                            if (additional_fee_setting_) {
                                additional_fee_setting_ = additional_fee_setting_.filter(item => item.status_);
                            }
                            StorageUtil.setItem(SystemConst.additionalFeeSetting, additional_fee_setting_);

                            StorageUtil.setItem(SystemConst.enableShopNoOrder, saleSetting.enable_shop_no_order_);
                            if (saleSetting.shop_no_order_time_) {
                                StorageUtil.setItem(SystemConst.shopNoOrderTime, JSON.parse(saleSetting.shop_no_order_time_));
                            }
                            // 预存款大于0不允许使用优惠券
                            StorageUtil.setItem(SystemConst.enablePreBalanceNoCoupon, saleSetting.enable_pre_balance_no_coupon_);
                        }
                        if (shopSetting) {
                            StorageUtil.setItem(SystemConst.messagePrompt, shopSetting.message_prompt_);
                            // 商品列表设置
                            StorageUtil.setItem(SystemConst.goodsListSetting, JSON.parse(shopSetting.goods_list_setting_json_));
                            // 商品分类设置
                            StorageUtil.setItem(SystemConst.goodsTypeSetting, JSON.parse(shopSetting.goods_type_setting_json_));

                            StorageUtil.setItem(SystemConst.shopSetting, shopSetting);
                            const enableShopClone = shopSetting.enable_shop_clone_ === 1 ? 1 : 0;
                            StorageUtil.setItem(SystemConst.enableShopClone, enableShopClone);
                            if (enableShopClone) {
                                CommonUtil.captureShopCloneEntryCodeFromUrl();
                            } else {
                                StorageUtil.delItem(SystemConst.shopCloneEntryCode);
                            }
                            StorageUtil.setItem(SystemConst.showGoodsDetailMode, shopSetting.show_goods_detail_mode_);
                            // 是否允许游客访问
                            StorageUtil.setItem(SystemConst.allowVisitor, shopSetting.allow_visitor_);
                            // 是否允许游客查看价格
                            StorageUtil.setItem(SystemConst.allowClientPrice, shopSetting.allow_client_price_);
                            // 商品列表展示类型
                            StorageUtil.setItem(SystemConst.showGoodsType, shopSetting.show_goods_type_);
                            // 商城标题
                            StorageUtil.setItem(SystemConst.showGoodsUnit, shopSetting.show_goods_unit_);
                            // 是否显示单位
                            StorageUtil.setItem(SystemConst.shopHomeTitle, shopSetting.shop_home_title_);
                            // 是否显示零售价
                            StorageUtil.setItem(SystemConst.showMarketPrice, shopSetting.enable_show_market_price_);

                            const navBarDecorate = JSON.parse(shopSetting.navigation_bar_decorate_);
                            const navBarJson = JSON.parse(shopSetting.navigation_bar_json_);
                            // 悬浮窗页面
                            StorageUtil.setItem(SystemConst.allowFloatingWindow, shopSetting.allow_floating_window_);
                            StorageUtil.setItem(SystemConst.floatingWindowDecorate, JSON.parse(shopSetting.floating_window_decorate_));
                            StorageUtil.setItem(SystemConst.floatingWindowJson, JSON.parse(shopSetting.floating_window_json_));
                            // 公共广告
                            const publicAdJson = JSON.parse(shopSetting.public_ad_json_);
                            StorageUtil.setItem(SystemConst.publicAdDecorate, JSON.parse(shopSetting.public_ad_decorate_));
                            StorageUtil.setItem(SystemConst.publicAdJson, publicAdJson);
                            StorageUtil.setItem(SystemConst.publicAdPosition, (publicAdJson || {}).position_ || 0);
                            // 导航应用页面
                            StorageUtil.setItem(SystemConst.navBarDecorate, navBarDecorate);
                            // 导航装修应用页面
                            if (shopSetting.navigation_bar_decorate_) {
                                const goodsTypeSetting = JSON.parse(shopSetting.goods_type_setting_json_);
                                const navDecoratePage = [];
                                navBarDecorate.forEach(item => {
                                    switch (item) {
                                        case 1:
                                            navDecoratePage.push(`/`);
                                            navDecoratePage.push(`/shop`);
                                            navDecoratePage.push(`/Shop`);
                                            break;
                                        case 2:
                                            navDecoratePage.push(`/shop/GoodsList`);
                                            break;
                                        case 3:
                                            navDecoratePage.push(`/shop/OrderList`);
                                            navDecoratePage.push(`/shop/RefundList`);
                                            break;
                                        case 4:
                                            navDecoratePage.push(`/shop/CartList`);
                                            break;
                                        case 5:
                                            navDecoratePage.push(`/shop/User`);
                                            break;
                                        case 6:
                                            navDecoratePage.push(goodsTypeSetting.show_type_ === 4 ? "/shop/GoodsGroupClassifyFilter" : "/shop/GoodsClassifyFilter");
                                            break;
                                        case 7:
                                            navDecoratePage.push(`/shop/page`);
                                            break;
                                    }
                                });
                                // 导航应用页面pathname
                                StorageUtil.setItem(SystemConst.navDecoratePage, navDecoratePage);
                                // 导航装修
                                StorageUtil.setItem(SystemConst.navBarJson, navBarJson);
                                const barPathname = CommonUtil.getBarPathname(navBarJson.buttons_);
                                // 导航装修路由
                                StorageUtil.setItem(SystemConst.barPathname, barPathname);
                            }

                            //个人中心设置
                            if (shopSetting.mine_page_json_) {
                                StorageUtil.setItem(SystemConst.MineSetting, JSON.parse(shopSetting.mine_page_json_));
                            }
                            //基础设置
                            if (shopSetting.base_setting_json_) {
                                StorageUtil.setItem(SystemConst.BaseSetting, JSON.parse(shopSetting.base_setting_json_));
                            }
                        }
                        if (distributionRebateSetting) {
                            StorageUtil.setItem(SystemConst.enableRebateLevel, distributionRebateSetting.enable_rebate_level_);
                            StorageUtil.setItem(SystemConst.distributionModelTitle, distributionRebateSetting.distribution_model_title_);
                            StorageUtil.setItem(SystemConst.distributionJobName, distributionRebateSetting.distribution_job_name_);
                            StorageUtil.setItem(SystemConst.posterBackground, distributionRebateSetting.poster_background_);
                            StorageUtil.setItem(SystemConst.invitationCardBackground, distributionRebateSetting.invitation_card_background_);
                            StorageUtil.setItem(SystemConst.joiningInstructions, distributionRebateSetting.joining_instructions_);
                            StorageUtil.setItem(SystemConst.bindWay, distributionRebateSetting.bind_way_);
                        }
                        if (top_goods_type_node_) {
                            StorageUtil.setItem(SystemConst.topGoodsTypeNode, top_goods_type_node_);
                        }
                        if (sceneSettingDto) {
                            StorageUtil.setItem(SystemConst.enableH5Scene, sceneSettingDto.enable_h5_scene_);
                        } else {
                            StorageUtil.setItem(SystemConst.enableH5Scene, null);
                        }
                        resolve(rs)
                    } else {
                        reject(rs)
                    }
                }, rs => {
                    reject(rs);
                })
            }
        )
            ;
    },
    getCompany(companyId) {
        return new Promise((resolve, reject) => {
            ShopFetch.getCompany(companyId, rs => {
                if (rs.status === 1) {
                    const {shopSettingDto} = rs.data;
                    // 公司信息
                    StorageUtil.setItem(SystemConst.companyData, rs.data);
                    // 公司名称
                    StorageUtil.setItem(SystemConst.companyName, rs.data.name_);
                    //设置页面标题
                    document.title = rs.data.name_;
                    // 公司id
                    StorageUtil.setItem(SystemConst.companyId, rs.data.id_);

                    StorageUtil.setItem(SystemConst.multi_currency_symbol_, rs.data.currency_type_ || '￥');
                    StorageUtil.setItem(SystemConst.currencySymbol, rs.data.currency_type_ || '￥');

                    resolve(rs)
                } else {
                    reject(rs)
                }
            }, rs => {
                reject(rs);
            })
        });
    },
    // 获取微信授权信息
    getWechatUserInfo(code, companyId) {
        console.log('getWeChatUserInfo');
        return new Promise((resolve, reject) => {

            System.getWeChatUserInfo({code: code, company_id_: companyId}, rs => {
                const query = CommonUtil.getSearchFromUrl();
                delete query.code;
                browserHistory.replaceState(null, location.pathname, query);
                console.log('clear location query.code');
                if (rs.status === 1) {
                    const {openid, errcode, headimgurl, nickname} = rs.data;
                    if (errcode) {
                        // 1.检查授权获取结果
                        switch (errcode) {
                            case 40001:
                                Toast.info('微信授权验证已过期', 1, null, false);
                                break;
                            default:
                                Toast.info('微信授权失败', 1, null, false);
                                break;
                        }
                        console.error('微信授权失败,错误信息', rs.data);
                    } else {
                        const isLogin = BusinessUtil.isLogin();
                        console.log('check user is login', isLogin);
                        if (isLogin) {
                            // A用户已登录
                            console.log('bind openid whit user', openid);
                            System.bindOpenId({wechat_openid_: openid, company_id_: companyId}, rs => {
                                if (rs.status === 1) {
                                    console.log('modify user bind state', true);
                                    StorageUtil.setItem(SystemConst.wechatBind, true);
                                    resolve(rs);
                                } else {
                                    reject(rs)
                                }
                            }, rs => {
                                reject(rs);
                            });
                        } else {
                            // B用户未登录
                            console.log('check user has bind');
                            System.openIdLogin({wechat_openid_: openid, company_id_: companyId}, rs => {
                                if (rs.status === 1) {
                                    console.log('loginStatus', rs.data);
                                    CommonUtil.checkLoginStatus(rs.data.loginStatus);
                                    if (rs.data.loginStatus == 1) {
                                        console.log('user is bind, auto login');
                                        // 本地保存登录信息
                                        CommonUtil.saveStorageFormLogin(rs.data.loginUser);
                                        /*YSDH-9108 取消reload, User GoodsDetail补充监听*/
                                    } else if (rs.data.loginStatus == 0) {
                                        console.log('store wechat user info');
                                        // 添加到缓存,'我的'页面展示
                                        StorageUtil.setItem(SystemConst.wechatData, {headimgurl, nickname, openid});
                                    } else {
                                        console.log('error user status, to origin login');
                                    }
                                    resolve(rs);
                                } else {
                                    reject(rs)
                                }
                            }, rs => {
                                reject(rs);
                            });
                        }
                    }
                    resolve(rs)
                } else {
                    reject(rs)
                }

            }, rs => {
                reject(rs);
            })
        });
    },
// 获取注册设置
    getShopRegisterSetting(companyId) {
        return new Promise((resolve, reject) => {
            ShopFetch.getShopRegisterSetting({company_id_: companyId}, rs => {
                if (rs.status === 1) {
                    const {register_agreement_set_, register_agreement_name_, register_agreement_url_, enable_application_, audit_} = rs.data;
                    StorageUtil.setItem(SystemConst.allowClientRegister, enable_application_);
                    StorageUtil.setItem('allowClientRegisterAudit', audit_);
                    StorageUtil.setItem('registerAgreement', {
                        register_agreement_set_, register_agreement_name_, register_agreement_url_
                    });
                    StorageUtil.setItem('shopRegisterSetting', rs.data);
                    resolve(rs)
                } else {
                    reject(rs)
                }
            })
        })
    },
// 获取客户信息
    getClientInfo(companyId) {
        return new Promise((resolve, reject) => {
            const ysUser = StorageUtil.getItem(SystemConst.mShop_user);
            if (ysUser && ysUser.client_id_) {
                System.getClientById(ysUser.client_id_, rs => {
                    if (rs.status === 1) {
                        StorageUtil.setItem(SystemConst.ysClient, rs.data);
                        System.getCompany(rs.data.company_id_, res => {
                            if (res.status === 1) {
                                StorageUtil.setItem(SystemConst.multi_currency_symbol_, res.data.currency_type_ || '￥');
                                StorageUtil.setItem(SystemConst.currencySymbol, res.data.currency_type_ || '￥');
                            }
                        });
                        resolve(rs)
                    } else {
                        reject(rs)
                    }
                });
            }
        })
    },
// 购物车数量
    getCartNumber() {
        const ysUser = StorageUtil.getItem(SystemConst.mShop_user);
        if (ysUser && ysUser.client_id_) {
            CartFetch.sumNumber(null, rs => {
                if (rs.status === 1) {
                    StorageUtil.setItem(SystemConst.cartCount, rs.data)
                }
            })
        }
    },
//商城端版本不一致,清除缓存
    cleanShopCache() {
        if (AppUtil.isApp) {
            System.getMobileShopVersion({}, rs => {
                if (rs.status == 1) {
                    const appVersion = StorageUtil.getItem('shopVersion');
                    if (appVersion) {
                        if (rs.data > appVersion) {
                            Util.title('登录过期', '登录过期，请重新登录', {confirmLabel: '确认'}).then(() => {
                                localStorage.clear();
                                sessionStorage.clear();
                                AppUtil.cleanCache();
                            });
                        }
                    } else {
                        StorageUtil.setItem('shopVersion', rs.data);
                    }
                }
            })
        }
    },

    // 客户设置
    getClientSetting() {
        return new Promise((resolve, reject) => {
            ShopFetch.getClientSetting({}, (rs) => {
                if (rs.status === 1) {
                    StorageUtil.setItem(SystemConst.clientSetting, rs.data);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            })
        });
    },

// 商品设置
    getGoodsSetting(companyId) {
        return new Promise((resolve, reject) => {
            ShopFetch.getGoodsSetting(companyId, (rs) => {
                if (rs.status === 1) {
                    // console.log(rs);
                    // 品牌数据列表
                    StorageUtil.setItem(SystemConst.brandList, rs.data.brandList);
                    // 风格数据列表
                    StorageUtil.setItem(SystemConst.styleList, rs.data.styleList);

                    StorageUtil.setItem(SystemConst.tagList, rs.data.tagList);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            })
        });
    },
    listTypeByCompany(companyId) {
        return new Promise((resolve, reject) => {
            ShopFetch.listTypeByCompany({companyId: companyId}, (rs) => {
                if (rs.status === 1) {
                    const handleRemoveIsShowShop = (list) => {
                        list.forEach(type => {
                            if (type.children && type.children.length > 0) {
                                type.children = handleRemoveIsShowShop(type.children)
                            }
                        });
                        return list.filter(item => item.fieldMap.is_display_store_);
                    };
                    rs.data.children = handleRemoveIsShowShop(rs.data.children);
                    StorageUtil.setItem(SystemConst.typeList, rs.data);
                    resolve(rs);
                } else {
                    reject(rs);
                }
            })
        });
    },

    getApplicationStatus(companyId) {
        return System.getApplicationStatus({company_id_: companyId}, rs => {
            if (rs.status === 1) {
                StorageUtil.setItem(SystemConst.applicationStatus, rs.data);
            }
        })

    },
    getUserInfo() {
        return System.getUserInfo(null, rs => {
            if (rs.status === 1) {
                StorageUtil.setItem(SystemConst.userInfo, rs.data);
            }
        })
    },

    getMsgSettingByCompanyId() {
        return System.getMsgSettingByCompanyId(null, rs => {
            if (rs.status === 1) {
                StorageUtil.setItem(SystemConst.msgSetting, rs.data);
            }
        })
    },

    getCustomerServiceList() {
        return System.getCustomerServiceList({}, rs => {
            if (rs.status === 1) {
                StorageUtil.setItem(SystemConst.customerServiceList, rs.data || []);
            }
        })
    },
};



// WEBPACK FOOTER //
// ./src/utils/common-utils.js